// DAS-3129: the latest TrendSearch story to show on a holding's alert card.
// Picks the newest row within the last 90 days; information only, no prediction.

const MAX_AGE_DAYS = 90;
const MAX_TEXT_LENGTH = 140;

const truncateAtWord = (text) => {
  if (text.length <= MAX_TEXT_LENGTH) return text;
  const cut = text.slice(0, MAX_TEXT_LENGTH);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
};

const hostWithoutWww = (url) => {
  try {
    const host = new URL(url).hostname;
    return host.startsWith('www.') ? host.slice(4) : host;
  } catch {
    return null;
  }
};

export default function latestAlertStory(rows, today = new Date()) {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  // Compare at UTC-midnight granularity so a "YYYY-MM-DD" row date (parsed as
  // UTC midnight) exactly 90 days back is kept regardless of today's time-of-day.
  const cutoff = new Date(Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate() - MAX_AGE_DAYS
  ));

  const newest = rows
    .filter((row) => row && row.date && row.full_description)
    .filter((row) => {
      const d = new Date(row.date);
      return !Number.isNaN(d.getTime()) && d >= cutoff;
    })
    .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

  if (!newest) return null;

  const source = hostWithoutWww(newest.article_url);

  return {
    text: truncateAtWord(String(newest.full_description)),
    date: newest.date,
    source,
    title: newest.article_title || null,
    url: newest.article_url || null,
  };
}
